var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEnforceCard01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blendFilter"
  }, /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImage",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1309_22724",
    x: -1.89453,
    y: 1.81567,
    width: 109,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1309_22724"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1309_22724",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1309_22724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1309_22724)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#blendFilter)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.1055,
    cy: 55.8157,
    r: 44,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1309_22724)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6055,
    cy: 52.8157,
    rx: 42.5,
    ry: 43,
    fill: "#78D3D0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.9078 38.9675L39.9922 37.2379L50.2928 19.6121L53.1993 21.3325L42.9078 38.9675Z",
    fill: "#D43E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0862 19.5479L47.1797 17.8183L58.5771 7.81567L61.4836 9.53616L50.0862 19.5479Z",
    fill: "#D43E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8336 40.4683L25.918 38.7478L39.9934 37.2378L42.909 38.9674L28.8336 40.4683Z",
    fill: "#D43E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32054 73.7158L6.41406 71.9953L25.9186 38.7478L28.8342 40.4683L9.32054 73.7158Z",
    fill: "#D43E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0841 19.5479L61.4816 9.53613L58.4106 24.3158L55.2939 22.5221L43.604 42.5365L29.5194 44.0465L11.4042 74.9238L9.32031 73.7158L28.8339 40.4683L42.9093 38.9674L53.2008 21.3324L50.0841 19.5479Z",
    fill: "#FA7564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5679 73.8178L54.8477 69.2445L54.977 40.3477L62.7053 44.921L62.5679 73.8178Z",
    fill: "#9CB5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7049 44.921L54.9766 40.3476L63.3759 35.5801L71.1042 40.1534L62.7049 44.921Z",
    fill: "#D7E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1071 40.1533L70.9696 69.042L62.5703 73.8177L62.7077 44.9209L71.1071 40.1533Z",
    fill: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9119 79.8725L44.1836 75.2992L44.2644 57.6616L51.9928 62.2349L51.9119 79.8725Z",
    fill: "#012234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.994 62.2349L44.2656 57.6616L52.6649 52.894L60.3933 57.4673L51.994 62.2349Z",
    fill: "#024462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3903 57.4674L60.3095 75.0969L51.9102 79.8726L51.991 62.235L60.3903 57.4674Z",
    fill: "#025A82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2515 85.9269L33.5312 81.3536L33.6363 59.0132L41.3566 63.5865L41.2515 85.9269Z",
    fill: "#A61D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.357 63.5865L33.6367 59.0132L42.036 54.2375L49.7644 58.8109L41.357 63.5865Z",
    fill: "#D43E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7625 58.8109L49.6574 81.1513L41.25 85.927L41.3551 63.5866L49.7625 58.8109Z",
    fill: "#FA7564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6033 91.852L22.875 87.2787L22.9316 74.9672L30.6599 79.5405L30.6033 91.852Z",
    fill: "#E08910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6619 79.5405L22.9336 74.9672L31.3329 70.1915L39.0613 74.7648L30.6619 79.5405Z",
    fill: "#F0A72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0575 74.7649L39.0009 87.0845L30.6016 91.8521L30.6582 79.5406L39.0575 74.7649Z",
    fill: "#FFCA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEnforceCard01);
export default __webpack_public_path__ + "static/media/img-enforce-card-01.709d100293eb1ef3147117c302b5b197.svg";
export { ForwardRef as ReactComponent };